import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ArticlesService } from '../../services/articles.service';
import { AuthProvider } from '../../services/auth.provider';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: 'forgotpassword.html',
  styleUrls: ['forgotpassword.scss']
})
export class ForgotPasswordPage {
  public model = new User('');
  public userstatus = false;
  public validation = false;

  constructor(private router: Router, private service: ArticlesService, private auth: AuthProvider) {}

  checkOnBlur() {
    if (this.model.username === '') {
      this.userstatus = false;
    } else {
      this.userstatus = true;
    }
    const patt = new RegExp('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-]{2,4}$');
    this.validation = patt.test(this.model.username);
  }

  sendEmail() {
    if (this.auth.isAuthenticated() || this.auth.isPartiallyAuthenticated()) {
      this.service.forgottenPasswordParent().subscribe((response) => {
        this.router.navigate(['merci'], { queryParams: { email: this.model.username }});
      });
    } else {
      this.service
        .forgottenPassword(this.model.username)
        .subscribe(() => this.router.navigate(['merci'], { queryParams: { email: this.model.username, page2: 'resetpass' }}));
    }
  }
}
